import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { colors, ThemeColor } from 'utils/colors'

import Text from '../Text'

type Props = {
  children?: ReactNode
  textColor?: ThemeColor
  bgColor?: string
  textAlignment?: 'center' | 'left' | 'right'
  shape?: 'rectangle' | 'arrow'
  onClick?: () => void
  width?: string
  height?: string
  lineHeight?: string
  borderRadius?: string
  borderWidth?: string
  borderStyle?: 'dashed' | 'dotted' | 'groove' | 'double' | 'inherit' | 'unset' | 'solid'
}

const Ribbon: React.FC<Props> = (props) => {
  const {
    children,
    textColor = 'black',
    bgColor = colors.gray1,
    onClick,
    textAlignment = 'center',
    borderStyle = 'dashed',
    borderWidth = '2px',
    borderRadius = '10px',
    width = '582px',
    height = '48px',
    lineHeight = '48px',
    shape = 'rectangle',
  } = props
  const content = typeof children === 'string' ? <Text color={textColor}>{children}</Text> : children

  return (
    <Container
      bgColor={bgColor}
      textAlignment={textAlignment}
      onClick={onClick}
      borderRadius={borderRadius}
      width={width}
      height={height}
      lineHeight={lineHeight}
      borderWidth={borderWidth}
      borderStyle={borderStyle}
      shape={shape}
    >
      {content}
    </Container>
  )
}

export default Ribbon

const rightTriangle = css<{
  bgColor: string
  textAlignment?: 'center' | 'left' | 'right'
  width?: string
  height?: string
  lineHeight?: string
  borderRadius?: string
  borderWidth?: string
  borderStyle?: 'dashed' | 'dotted' | 'groove' | 'double' | 'inherit' | 'unset' | 'solid'
  shape?: 'rectangle' | 'arrow'
}>`
  &::after {
    content: '';
    border-top: ${({ borderWidth }) => (borderWidth ? borderWidth : '1px')}
      ${({ borderStyle }) => (borderStyle ? borderStyle : 'solid')} ${({ theme }) => theme.colors.gray3};
    border-right: ${({ borderWidth }) => (borderWidth ? borderWidth : '1px')}
      ${({ borderStyle }) => (borderStyle ? borderStyle : 'solid')} ${({ theme }) => theme.colors.gray3};
    width: 35px;
    height: 35px;
    position: absolute;
    right: -19px;
    top: 6px;
    background-color: ${({ bgColor }) => bgColor};
    z-index: 0;
    transform: rotate(45deg);
    overflow: hidden;
  }
`

const Container = styled.div<{
  bgColor: string
  textAlignment?: 'center' | 'left' | 'right'
  width?: string
  height?: string
  lineHeight?: string
  borderRadius?: string
  borderWidth?: string
  borderStyle?: 'dashed' | 'dotted' | 'groove' | 'double' | 'inherit' | 'unset' | 'solid'
  shape?: 'rectangle' | 'arrow'
}>`
  cursor: ${(p) => (p.onClick ? 'pointer' : 'default')};
  display: flex;
  align-items: center;
  position: relative;
  height: ${({ height }) => (height ? height : 'auto')};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : 'auto')};
  padding: 0 ${({ shape }) => (shape === 'arrow' ? '7px' : '16px')} 0 16px;
  border: ${({ borderWidth }) => (borderWidth ? borderWidth : '1px')}
    ${({ borderStyle }) => (borderStyle ? borderStyle : 'solid')} ${({ theme }) => theme.colors.gray3};
  width: ${({ width }) => (width ? width : 'auto')};
  text-align: ${({ textAlignment }) => textAlignment};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : 'auto')}
    ${({ shape, borderRadius }) => (shape === 'arrow' ? '0 0' : `${borderRadius} ${borderRadius}`)}
    ${({ borderRadius }) => (borderRadius ? borderRadius : 'auto')};
  flex-grow: 1;
  background-color: ${({ bgColor }) => bgColor};
  user-select: none;
  ${({ shape }) => (shape === 'arrow' ? rightTriangle : null)}
`
